/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { FiArrowLeft } from 'react-icons/fi';
import './PackageSummaryBar.scss';

/** The dark summary strip every eSIM / visa page opens with, for packages. */
function PackageSummaryBar({ items, onBack, backLabel, actions }) {
  return (
    <section className="pkg-summary-bar">
      <Container>
        <div className="pkg-summary-bar__inner">
          {onBack && (
            <button
              type="button"
              className="pkg-summary-bar__back"
              onClick={onBack}
              aria-label={backLabel}
              title={backLabel}
            >
              <FiArrowLeft />
            </button>
          )}
          {items
            .filter((item) => item && item.value)
            .map((item) => (
              <div className="pkg-summary-bar__meta" key={item.label}>
                <span className="pkg-summary-bar__label">
                  {item.icon}
                  {item.label}
                </span>
                <strong className="pkg-summary-bar__value">{item.value}</strong>
              </div>
            ))}
          {actions && <div className="pkg-summary-bar__actions">{actions}</div>}
        </div>
      </Container>
    </section>
  );
}

PackageSummaryBar.propTypes = {
  items: PropTypes.array.isRequired,
  onBack: PropTypes.func,
  backLabel: PropTypes.string,
  actions: PropTypes.node,
};

PackageSummaryBar.defaultProps = {
  onBack: null,
  backLabel: 'Back',
  actions: null,
};

export default PackageSummaryBar;
